import { render, staticRenderFns } from "./pointProduct.vue?vue&type=template&id=65cd0a0e&scoped=true&"
import script from "./pointProduct.vue?vue&type=script&lang=js&"
export * from "./pointProduct.vue?vue&type=script&lang=js&"
import style0 from "./pointProduct.vue?vue&type=style&index=0&id=65cd0a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd0a0e",
  null
  
)

export default component.exports